import { useEffect } from "react";

export const SITE = process.env.REACT_APP_SITE_URL;
const BRAND = "Giochi.Gratis";
const DEFAULT_TITLE = "Giochi Online Gratis senza Download | Giochi.Gratis";
const DEFAULT_DESC = "Gioca gratis a migliaia di giochi online dal browser: azione, corse, puzzle, sport e tanto altro. Niente download, niente registrazione, anche da smartphone.";

function setTag(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!value) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = create();
    el.dataset.dyn = "1";
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

const meta = (key, name, value) =>
  setTag(`meta[${key}="${name}"]`, () => {
    const m = document.createElement("meta");
    m.setAttribute(key, name);
    return m;
  }, "content", value);

export const clip = (s, n = 155) => {
  s = String(s || "").replace(/\s+/g, " ").trim();
  if (s.length <= n) return s;
  const cut = s.slice(0, n - 1);
  return cut.slice(0, cut.lastIndexOf(" ") > 80 ? cut.lastIndexOf(" ") : cut.length) + "…";
};

export const withBrand = (t) => (t.length + BRAND.length + 3 <= 60 ? `${t} | ${BRAND}` : t);

export function useSeo({ title, description, path, image, jsonld, noindex = false, type = "website" } = {}) {
  const ld = jsonld ? JSON.stringify(jsonld) : "";
  useEffect(() => {
    const fullTitle = title ? withBrand(title) : DEFAULT_TITLE;
    const desc = clip(description || DEFAULT_DESC, 160);
    const url = path != null && SITE ? `${SITE}${path}` : "";
    const img = image || (SITE ? `${SITE}/og-image.jpg` : "");
    document.title = fullTitle;
    meta("name", "description", desc);
    meta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
    meta("property", "og:title", fullTitle);
    meta("property", "og:description", desc);
    meta("property", "og:type", type);
    meta("property", "og:url", url);
    meta("property", "og:image", img);
    meta("name", "twitter:title", fullTitle);
    meta("name", "twitter:description", desc);
    meta("name", "twitter:image", img);
    setTag('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }, "href", noindex ? "" : url);
    let s = document.getElementById("ld-page");
    if (ld) {
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "ld-page";
        document.head.appendChild(s);
      }
      s.textContent = ld;
    } else if (s) s.remove();
  }, [title, description, path, image, ld, noindex, type]);
}

export const crumbs = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, p], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE}${p}` })),
});
